import i18n from '../../../../../../i18n'

export const columns = [
    {
        field: 'placeNumber',
        headerName: i18n.t('Position'),
        width: '15%',
    },
    {
        field: 'name',
        headerName: i18n.t('Name'),
        width: '20%',
    },
    {
        field: 'email',
        headerName: i18n.t('Email'),
        width: '30%',
    },
    {
        field: 'credential',
        headerName: i18n.t('Credential'),
        width: '25%',
    },
    {
        field: 'numberOfGames',
        headerName: i18n.t('Number of tries'),
        width: '20%',
    },
    {
        field: 'numberOfInteractions',
        headerName: i18n.t('Number of Interactions'),
        width: '25%',
    },
    {
        field: 'passingTime',
        headerName: i18n.t('Best time'),
        width: '15%',
    },
]
